// Original Figma SVG assets. Keep their intrinsic 16×16 geometry and paint.
export function DesignIcon({ name }: { name: "compare" | "analytics" | "library" | "history" | "settings" }) {
  return <span className="design-icon" aria-hidden="true">
    <img src={`/design-system/${name}-light.svg`} className="design-icon-light" alt="" />
    <img src={`/design-system/${name}-dark.svg`} className="design-icon-dark" alt="" />
  </span>;
}
